import SelectRoleNavigation from "../SelectRoleNavigation.jsx";

export default function ({ num, handleIncrement }) {
  return (
    <>
      <SelectRoleNavigation
        currentStep={num}
        title="Select a role that you are looking for"
        text="One selection"
        handleIncrement={handleIncrement}
      />
      <div className="container">
        <div className="company-rol-first-step step-wrapper-all">
          <label>
            <input
              type="radio"
              value="Post Sale"
              name="current_role"
              defaultChecked
            />
            <span>
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.1208 3.67652L3.63672 12.0675L6.06075 14.4649L14.5448 6.07394L12.1208 3.67652Z"
                  fill="#4F4A62"
                />
                <path
                  d="M8.48389 12.0673L2.42383 6.07373L-0.000197658 8.47116L6.05987 14.4647L8.48389 12.0673Z"
                  fill="#4F4A62"
                />
              </svg>

              <svg
                width="223"
                height="62"
                viewBox="0 0 223 62"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="180.366"
                  y="11.5696"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(-45 180.366 11.5696)"
                  fill="#FCE80F"
                />
                <rect
                  x="211.219"
                  y="19.2825"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(45 211.219 19.2825)"
                  fill="#FCE80F"
                />
                <rect
                  x="140.096"
                  y="11.5696"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(-45 140.096 11.5696)"
                  fill="#FF6633"
                />
                <rect
                  x="170.948"
                  y="19.2825"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(45 170.948 19.2825)"
                  fill="#FF6633"
                />
                <rect
                  x="99.8242"
                  y="11.5696"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(-45 99.8242 11.5696)"
                  fill="#764AFF"
                />
                <rect
                  x="130.677"
                  y="19.2825"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(45 130.677 19.2825)"
                  fill="#764AFF"
                />
                <rect
                  x="59.5527"
                  y="11.5696"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(-45 59.5527 11.5696)"
                  fill="#29B8FF"
                />
                <rect
                  x="90.4053"
                  y="19.2826"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(45 90.4053 19.2826)"
                  fill="#29B8FF"
                />
                <rect
                  x="19.2822"
                  y="11.5696"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(-45 19.2822 11.5696)"
                  fill="#28DDCF"
                />
                <rect
                  x="50.1348"
                  y="19.2826"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(45 50.1348 19.2826)"
                  fill="#28DDCF"
                />
              </svg>

              <h3>Post-Sales</h3>
              <p>
                Ensures customers successfully use the product, solve any
                issues, and stay satisfied e.g. Solutions Architects.
              </p>
            </span>
          </label>
          <label>
            <input type="radio" value="Pre Sale" name="current_role" />
            <span>
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.1208 3.67652L3.63672 12.0675L6.06075 14.4649L14.5448 6.07394L12.1208 3.67652Z"
                  fill="#4F4A62"
                />
                <path
                  d="M8.48389 12.0673L2.42383 6.07373L-0.000197658 8.47116L6.05987 14.4647L8.48389 12.0673Z"
                  fill="#4F4A62"
                />
              </svg>
              <svg
                width="223"
                height="62"
                viewBox="0 0 223 62"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="42.4219"
                  y="50.1345"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(135 42.4219 50.1345)"
                  fill="#FCE80F"
                />
                <rect
                  x="11.5693"
                  y="42.4216"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(-135 11.5693 42.4216)"
                  fill="#FCE80F"
                />
                <rect
                  x="82.6924"
                  y="50.1345"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(135 82.6924 50.1345)"
                  fill="#FF6633"
                />
                <rect
                  x="51.8398"
                  y="42.4216"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(-135 51.8398 42.4216)"
                  fill="#FF6633"
                />
                <rect
                  x="122.964"
                  y="50.1345"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(135 122.964 50.1345)"
                  fill="#764AFF"
                />
                <rect
                  x="92.1113"
                  y="42.4216"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(-135 92.1113 42.4216)"
                  fill="#764AFF"
                />
                <rect
                  x="163.235"
                  y="50.1343"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(135 163.235 50.1343)"
                  fill="#29B8FF"
                />
                <rect
                  x="132.383"
                  y="42.4214"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(-135 132.383 42.4214)"
                  fill="#29B8FF"
                />
                <rect
                  x="203.506"
                  y="50.1344"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(135 203.506 50.1344)"
                  fill="#28DDCF"
                />
                <rect
                  x="172.653"
                  y="42.4214"
                  width="16.3617"
                  height="43.6312"
                  transform="rotate(-135 172.653 42.4214)"
                  fill="#28DDCF"
                />
              </svg>

              <h3>Pre Sales</h3>
              <p>
                Helps potential customers understand the product, see its value,
                and decide to buy e.g. Sales Engineers.
              </p>
            </span>
          </label>
        </div>
      </div>
    </>
  );
}
